<template>
  <div>
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6" lg="4" xl="3" class="d-flex justify-center">
        <v-card class="email-insert-card elevation-2">
          <v-col
            cols="12"
            style="background-color: #f96654"
            class="d-flex align-center justify-center pa-4"
          >
            <img
              :src="require('../../assets/Dynamic_Pricing.svg')"
              class="logo-image"
              alt="Dynamic Pricing Logo"
            />
          </v-col>
          <v-card-text class="pa-6">
            <v-form
              ref="email_insert_form"
              id="email_insert_form"
              lazy-validation
            >
              <div class="email-content">
                <h2 class="text-h5 font-weight-bold mb-6 text-center">Enter your email</h2>
                <v-text-field
                  prepend-inner-icon="mdi-email"
                  ref="email_crawlo"
                  v-model="resetEmail"
                  label="Email"
                  placeholder="Enter your email address"
                  :error="isWrong"
                  :rules="[rules.required, rules.emailValidation]"
                  required
                  dense
                  class="mb-4"
                ></v-text-field>
                <div class="d-flex flex-column flex-sm-row gap-2">
                  <v-btn 
                    text 
                    color="primary"
                    @click="gotoLogin()"
                    class="order-2 order-sm-1"
                  >
                    <v-icon left>mdi-arrow-left</v-icon>
                    Back to Sign In
                  </v-btn>
                  <v-spacer class="d-none d-sm-flex"></v-spacer>
                  <v-btn 
                    color="error" 
                    @click="submitEmail"
                    class="order-1 order-sm-2"
                    :disabled="!resetEmail"
                  >
                    Send Reset Link
                  </v-btn>
                </div>
              </div>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="12" class="d-flex justify-center">
        <v-alert
          v-model="isWrong"
          color="error"
          dark
          border="left"
          icon="mdi-alert"
          transition="scale-transition"
          dismissible
          class="mobile-alert"
        >
          No account found with that email address
        </v-alert>
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "EmailInsert",

  data: () => {
    return {
      resetEmail: "",
      isWrong: false,
      rules: {
        required: (value) => !!value || "This field is required.",
        emailValidation: (value) =>
          /.+@.+\..+/.test(value) || "Email not valid.",
      },
    };
  },
  methods: {
    gotoLogin() {
      this.$router.push("/login");
    },
    async submitEmail() {
      if (this.$refs.email_insert_form.validate()) {
        let res = await this.$store.dispatch("RESET_REQUEST", {
          resetEmail: this.resetEmail,
        });
        if (res.data.status === "error") {
          this.isWrong = true;
        } else {
          this.isWrong = false;
          this.$router.push({
            path: "/login",
            query: { from_insert_email: true },
          });
        }
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
/* Mobile-friendly card */
.email-insert-card {
  width: 100%;
  max-width: 500px;
  margin: 0 16px;
}

/* Desktop card width */
@media (min-width: 960px) {
  .email-insert-card {
    width: 100%;
    margin: 0;
  }
}

/* Mobile-friendly logo */
.logo-image {
  max-width: 220px;
  width: 100%;
  height: auto;
}

/* Responsive content padding */
.email-content {
  padding: 0;
}

@media (max-width: 599px) {
  .email-content {
    padding: 0 8px;
  }
}

/* Mobile-friendly alert */
.mobile-alert {
  width: 100%;
  max-width: 500px;
  margin: 0 16px;
}

@media (min-width: 960px) {
  .mobile-alert {
    width: auto;
    margin: 0;
  }
}

/* Button spacing on mobile */
@media (max-width: 599px) {
  .gap-2 {
    gap: 8px;
  }
  
  .v-btn {
    min-height: 48px; /* Better touch targets */
    width: 100%;
  }
}

/* Desktop button layout */
@media (min-width: 600px) {
  .gap-2 {
    gap: 16px;
  }
  
  .v-btn {
    width: auto;
  }
}

/* Improve form spacing */
@media (max-width: 599px) {
  .v-text-field {
    margin-bottom: 16px;
  }
}

/* Better typography on mobile */
@media (max-width: 599px) {
  .text-h5 {
    font-size: 1.25rem !important;
  }
}
</style>
